// @flow

import _ from 'lodash';

import ReduceStore from 'PMT/flux/ReduceStore';

import { browserHistory } from 'react-router';
import Route from 'PMT/flux/Route';

import SessionStore from './SessionStore';

import { Events, ActionTypes } from 'constants';

import RouteAction from '../actions/RouteAction';
import RoutingEnum from 'constants/RoutingEnum';

class RouteStore extends ReduceStore {

  getInitialState() {
    return {
      queryParams: null,
    }
  }

  isEmitingCustomEvents(): boolean {
    return true;
  }

  getStateObjectsMap() {
    return {
    }
  }

  redirectToHome() {
    browserHistory.push('app');
  }

  redirectTo(route:Route, params = null, query = null) {
    if (_.isNull(params)) {
      browserHistory.push({
        pathname: route.path,
        query
      });
    } else {
      browserHistory.push({
        pathname: route.generatePathWithParams(params),
        query
      });
    }
  }

  getNewQueryParams(): Object {
    return this._state.queryParams;
  }

  reduce(state, action, nextState) {
    switch (action.type) {

      case ActionTypes.REDIRECT:
        this.redirectTo(action.route, action.params, action.query);
        return nextState;

      case ActionTypes.LOGOUT:
        setTimeout(() => {
          RouteAction.redirect(RoutingEnum.LOGIN);
        }, 2000);
        return nextState;

      case ActionTypes.QUERY_PARAMS_UPDATE:
        nextState.queryParams = action.queryParams;
        this.emitEvent(Events.ON_QUERY_PARAMS_UPDATE);
        return nextState;

      default:
        return nextState;
    }
  }

}

export default new RouteStore();



// WEBPACK FOOTER //
// ./scripts/stores/RouteStore.js